import React, { useRef, useEffect } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import apisecured from "../../api/apisecured";
import { setToast } from "../../State/toastSlice";
import { useDispatch } from "react-redux";

const PayPalButtonGroup = ({
  currency,
  userlogin,
  goaluuid,
  amountRef,
  name,
  message,
  isPrivateMessage,
  ReceipentUID,
  isGeneralDonation = false,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const messageRef = useRef(message);
  const receipentUIDRef = useRef(ReceipentUID);
  const nameRef = useRef(name);
  const isPrivateMessageRef = useRef(isPrivateMessage);

  // Update the ref value whenever `message` changes
  useEffect(() => {
    messageRef.current = message;
  }, [message]);
  useEffect(() => {
    receipentUIDRef.current = ReceipentUID;
  }, [ReceipentUID]);
  useEffect(() => {
    nameRef.current = name;
  }, [name]);

  useEffect(() => {
    isPrivateMessageRef.current = isPrivateMessage;
  }, [isPrivateMessage]);

  return (
    <div
      style={{ colorScheme: "none" }}
      className={isGeneralDonation ? "" : "bg-[#030021]"}
    >
      <PayPalScriptProvider
        options={{
          "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: currency,
          components: "buttons",
        }}
      >
        <div className="mt-2">
          {/* Pay with PayPal button */}
          <PayPalButtons
            fundingSource="paypal"
            style={{
              shape: "pill",
              layout: "vertical",
              color: "blue",
              label: "paypal",
            }}
            createOrder={async () => {
              const amountToSend = amountRef.current;
              const amountInCents = Math.round(
                parseFloat(amountRef.current) * 100,
              );
              if (!amountToSend || parseFloat(amountToSend) <= 0) {
                dispatch(
                  setToast({
                    message: "Please enter a valid amount.",
                    type: "error",
                  }),
                );
                return Promise.reject(new Error("Invalid amount"));
              }

              try {
                const payload = {
                  // UID: userlogin.uid,
                  GoalUid: goaluuid,
                  amount: amountInCents,
                  name: nameRef.current.trim(),
                  message: messageRef.current.trim(),
                  ReceipentUID: receipentUIDRef.current,
                  isPrivateMessage: isPrivateMessageRef.current,
                };
                const { data } = await apisecured.post(
                  "paypal/create-order",
                  payload,
                );
                return data.orderId;
              } catch (error) {
                console.error("Error creating PayPal order:", error);
                return Promise.reject(error);
              }
            }}
            onApprove={async (data) => {
              try {
                const { data: orderData } = await apisecured.post(
                  `paypal/capture-order/${data.orderID}`,
                );

                localStorage.setItem("paymentUserName", nameRef.current.trim());
                localStorage.setItem(
                  "paymentIsPrivateMessage",
                  isPrivateMessageRef.current,
                );
                localStorage.setItem(
                  "paymentSendAsAnonymous",
                  nameRef.current.trim() === "Anonymous",
                );
                if (typeof onSuccess === "function") {
                  onSuccess(); // Call onSuccess if it’s a function
                } else {
                  console.warn("onSuccess is not a function or is undefined.");
                }
              } catch (error) {
                dispatch(
                  setToast({
                    message: "Error capturing PayPal order.",
                    type: "error",
                  }),
                );
                console.error("Error capturing PayPal order:", error);
              }
            }}
            onError={(err) => {
              console.error("PayPal Button Error:", err);
            }}
          />
          {/* Pay with Card button */}
          <PayPalButtons
            fundingSource="card"
            style={{
              shape: "pill",
              layout: "vertical",
              color: "black",
              label: "pay",
            }}
            createOrder={async () => {
              const amountToSend = amountRef.current;
              const amountInCents = Math.round(
                parseFloat(amountRef.current) * 100,
              );

              if (!amountToSend || parseFloat(amountToSend) <= 0) {
                dispatch(
                  setToast({
                    message: "Please enter a valid amount.",
                    type: "error",
                  }),
                );
                return Promise.reject(new Error("Invalid amount"));
              }

              try {
                const payload = {
                  GoalUid: goaluuid,
                  amount: amountInCents,
                  name: nameRef.current.trim(),
                  message: messageRef.current.trim(),
                  ReceipentUID: receipentUIDRef.current,
                  isPrivateMessage: isPrivateMessageRef.current,
                };

                const response = await apisecured.post(
                  "paypal/create-order",
                  payload,
                );
                return response.data.orderId;
              } catch (error) {
                console.error("Error creating PayPal order:", error);
                dispatch(
                  setToast({
                    message:
                      error.response?.data?.ErrorMessage ||
                      "Error creating PayPal order.",
                    type: "error",
                  }),
                );
                return Promise.reject(error);
              }
            }}
            onApprove={async (data) => {
              try {
                const response = await apisecured.post(
                  `paypal/capture-order/${data.orderID}`,
                );
                localStorage.setItem("paymentUserName", nameRef.current.trim());
                localStorage.setItem(
                  "paymentIsPrivateMessage",
                  isPrivateMessageRef.current,
                );
                localStorage.setItem(
                  "paymentSendAsAnonymous",
                  nameRef.current.trim() === "Anonymous",
                );
                onSuccess();
              } catch (error) {
                console.error("Error capturing PayPal order:", error);
                dispatch(
                  setToast({
                    message:
                      error.response?.data?.ErrorMessage ||
                      "Error capturing PayPal order.",
                    type: "error",
                  }),
                );
              }
            }}
            onError={(err) => {
              console.error("PayPal Button Error:", err);
            }}
          />
        </div>
      </PayPalScriptProvider>
    </div>
  );
};

export default PayPalButtonGroup;
